import { registerLocaleData } from '@angular/common';
import localeRu from '@angular/common/locales/ru';

/**
 * BE-601: Angular `DatePipe`/`formatDate`/`formatNumber` с явной локалью 'ru'/'ru-RU'
 * бросали NG0701 (Missing locale data), т.к. данные локали не были зарегистрированы,
 * а `LOCALE_ID` не настроен. Регистрируем данные ru-локали один раз на старте приложения —
 * это гасит NG0701 во всех местах, где используется Angular-локализация.
 *
 * `registerLocaleData(localeRu)` регистрирует данные под каноническим id 'ru'; вызовы с
 * 'ru-RU' резолвятся к 'ru' через parent-locale fallback Angular, поэтому отдельная
 * регистрация 'ru-RU' не нужна. `LOCALE_ID` намеренно НЕ меняем (минимальный радиус):
 * «голые» `| date`-пайпы остаются на дефолтном en-US.
 */
registerLocaleData(localeRu);
